import { render } from "./PatientReportReadingView.vue?vue&type=template&id=585896cc&scoped=true"
import script from "./PatientReportReadingView.vue?vue&type=script&lang=js"
export * from "./PatientReportReadingView.vue?vue&type=script&lang=js"

import "./PatientReportReadingView.vue?vue&type=style&index=0&id=585896cc&lang=css&scoped=true"

import exportComponent from "/home/runner/work/Frontend_PsicoApp/Frontend_PsicoApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585896cc"]])

export default __exports__